// extracted by mini-css-extract-plugin
export default {"desktop":"style_desktop__15noP","view":"style_view__AGC55","mobile":"style_mobile__0lamZ","laptop":"style_laptop__IG3Jb"};